
















































import Vue from 'vue'
import { range } from '@/common/utils'

export default Vue.extend({
  props: {
    totalNumberOfItems: {
      type: Number,
      required: true
    },
    numberOfItemsPerPage: {
      type: Number,
      required: true
    },
    /**
     * Number of maximum items to display in pages.
     * For example
     * 10 pages: [Prev] 1 2 3 4 5 6 7 8 9 10 [Next]
     * 05 pages: [Prev] 4 5 6 7 8 [Next]
     */
    maxNumberOfDisplayPages: {
      type: Number,
      required: true
    },
    selectedPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    numberOfPages(): number {
      return Math.ceil(this.totalNumberOfItems / this.numberOfItemsPerPage)
    },
    isFirstPage(): boolean {
      return this.selectedPage === 1
    },
    isLastPage(): boolean {
      return this.selectedPage == this.numberOfPages
    },
    displayPageNumbersList(): number[] {
      let threshold
      let startPage
      let endPage

      if (this.maxNumberOfDisplayPages % 2) {
        threshold = Math.floor(this.maxNumberOfDisplayPages / 2)
        startPage = this.selectedPage - threshold
        endPage = this.selectedPage + threshold
      }
      else {
        threshold = this.maxNumberOfDisplayPages / 2
        startPage = this.selectedPage - threshold + 1
        endPage = this.selectedPage + threshold
      }


      const toTrim = this.numberOfPages > this.maxNumberOfDisplayPages
      const isInBetweenNumber = threshold < this.selectedPage && this.selectedPage <= this.numberOfPages - threshold
      const isBeginningNumber = 0 < this.selectedPage && this.selectedPage <= threshold
      const isEndingNumber = this.numberOfPages - threshold < this.selectedPage && this.selectedPage <= this.numberOfPages

      if (!toTrim) return range(1, this.numberOfPages)
      else if (isBeginningNumber) return range(1, this.maxNumberOfDisplayPages)
      else if (isInBetweenNumber) return range(startPage, endPage)
      else if (isEndingNumber) return range(this.numberOfPages - this.maxNumberOfDisplayPages + 1, this.numberOfPages)
      else throw new Error('Selected page out of range')
    }
  },
  methods: {
    selectPage(pageNumber: number) {
      if (pageNumber < 1) return
      if ( pageNumber > this.numberOfPages) return
      this.$emit('selectPage', pageNumber)
    }
  }
})
